// Activity type constants
export const ACTIVITY_TYPES = {
  TLM: "TLM",
  CONSUMABLES: "CONSUMABLES",
  BOTH: "BOTH",
  TECH: "TECH",
  NONE: "NONE",
} as const;

export const KIT_TYPES_OPTIONS = {
  TLM: "TLM",
  Books: "Books",
} as const;

// Form field constants
export const CURRICULUM_TOPIC = "curriculumTopic";
export const ACADEMIC_YEAR = "academicYear";
export const APPLICABLE_GRADES = "applicableGrades";

// Additional constants for forms
export const GRADES = "grades";
export const MODULE = "moduleId";
export const SUB_MODULE = "submoduleId";
export const TOPIC = "curriculumTopic";
export const YEAR = "academicYear";
export const ACTIVITY_TYPE = "activityType";
export const TOPIC_TLM = "topicTLM";
export const DESCRIPTION = "description";
export const KIT_NAME = "kitName";
export const KIT_TYPE = "kitType";
